import { withStyles } from "@material-ui/core";
import { smartDateFormat } from "app/Core/Helpers";
import clsx from 'clsx';
import _ from 'lodash';
import React from "react";
import MensagemIcone from "../../Components/MensagemIcone";

const styles = theme => ({
    box: {
        border: "1px solid " + theme.palette.divider,
        borderRadius: 4,
        "&.novo": {
            fontWeight: 700,
            borderColor: theme.palette.type === 'light' ? '#303030' : '#E6E6E6',
        }
    },
});

const Mensagem = (props) => {

    const { get, xappRouteParams, classes, filtro, setOpenMessage } = props;
    filtro.AND.push({ "Campo": "mensagem.idmensagem", "Operador": "=", "Valor": props.data.idmensagem });

    return (
        <React.Fragment>
            <div
                className={clsx(classes.box, "flex w-full px-8 py-4 mb-4 items-center gap-8 min-h-44 cursor-pointer", (props.data.lido === 0) && "novo")}
                onClick={() => {
                    if (props.data.mensagemSistema) {
                        setOpenMessage(props.data);
                    }
                    else {
                        get("SELECIONAR", xappRouteParams, filtro);
                    }
                }}
            >
                <MensagemIcone
                    {...props.data.notificacao}
                />
                <div className="w-full">
                    <div className="flex">
                        <span className={clsx(" w-full whitespace-no-wrap")}>
                            {props.data.remetente}
                        </span>
                        <span className={clsx(" w-fit text-11 whitespace-no-wrap")}>
                            {smartDateFormat(props.data.dataupt)}
                        </span>
                    </div>
                    <span className={clsx(" w-full whitespace-no-wrap")}>
                        {`Ref: ${!_.isNull(props.data.assunto) ? props.data?.assunto : ""}`}
                    </span>
                </div>
            </div>
        </React.Fragment>
    );
}



export default withStyles(styles, { withTheme: true })(Mensagem);